<div class="input-group">
  <button
    class="ms-1"
    mat-stroked-button
    id="addButtonGroup"
    aria-expanded="false"
    (click)="add()">
    Add
  </button>

  @if (excelExporting!) {
    <button
      class="ms-1"
      mat-stroked-button
      aria-expanded="false"
      (click)="excelExport()">
      Export Excel
    </button>
  }
</div>